import { render, staticRenderFns } from "./ProjectListEdit.vue?vue&type=template&id=38d6b966"
import script from "./ProjectListEdit.vue?vue&type=script&lang=js"
export * from "./ProjectListEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports